import React, { FC } from "react";
import { QuestionConfigDetailDto } from "@green0meter/api-client";
import { useTranslation } from "react-i18next";

import { Button, Stack } from "@components/base";

interface Actions {
  questionConfig: QuestionConfigDetailDto;
  disabled: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

const Actions: FC<Actions> = ({ questionConfig, disabled, onCancel, onSubmit }) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" justifyContent="space-between" spacing={2}>
      <Button variant="outlined" onClick={onCancel} disabled={disabled}>
        {t("common.cancel")}
      </Button>
      <Button variant="contained" onClick={onSubmit} disabled={disabled}>
        {questionConfig.id ? t("common.save") : t("common.create")}
      </Button>
    </Stack>
  );
};

export default Actions;
